module.exports = __webpack_public_path__ + "img/course-15.54abd791.png";